import React from 'react';

import { BsQuestionCircleFill } from 'react-icons/bs';

import { TkTayaraToken } from '@/tayara-kit/icons';
import Text from '@/tayara-kit/Text';
import Tooltip from '@/tayara-kit/Tooltip';

interface BoostCardProps extends React.HTMLAttributes<HTMLDivElement> {
  figure: JSX.Element;
  title: string;
  description: string;
  className?: string;
  action: () => void;
  price?: number;
  tooltip?: JSX.Element;
  renderAction?: JSX.Element;
}

const BoostCard: React.FC<BoostCardProps> = ({
  figure,
  title,
  description,
  className,
  action,
  price,
  tooltip,
  renderAction,
}) => (
  <>
    {renderAction || (
      <div
        className={`relative bg-neutral-50 border-neutral-200 cursor-pointer shadow-lg lg:shadow-none border-[1px] w-full lg:w-[300px] rounded-xl px-2 lg:px-3 py-4 lg:py-8 flex lg:flex-col items-center justify-start shrink group ${className}`}
        onClick={action}
      >
        {/* Figure goes here */}
        {figure}

        {/* Content */}
        <div className="flex flex-col justify-between h-full items-start lg:items-center">
          <div className="flex flex-col justify-center items-start lg:items-center gap-y-2 lg:m-4 m-2">
            <div className="flex justify-center items-start lg:items-center lg:gap-x-2">
              {/* <CgBolt className="lg:hidden text-gray-600" size={40} /> */}

              <Text
                text={title}
                as="h2"
                className="font-bold text-base lg:text-lg text-gray-600 truncate"
              />
              {tooltip && (
                <div className="hidden lg:group-hover:block lg:hidden z-50">
                  <Tooltip component={tooltip}>
                    <BsQuestionCircleFill className="text-gray-600" size={14} />
                  </Tooltip>
                </div>
              )}
            </div>
            {price && (
              <div className="text-xs flex justify-center items-center gap-x-1 text-blue-500">
                <TkTayaraToken size={18} />

                <span className="font-medium text-xs md:text-sm">{price}</span>
                <span className="font-medium text-xs md:text-sm">tokens</span>
              </div>
            )}
            <Text
              text={description}
              as="p"
              className="font-light text-gray-700 text-xs md:text-sm lg:text-center leading-snug lg:mx-4 "
            />
          </div>

          {/* Action */}

          <button
            className="hidden lg:block w-full p-3 mb-0 uppercase tracking-[0.2rem] font-normal text-2xs bg-white text-gray-700 rounded-md border-[1px] border-neutral-200 group-hover:text-white group-hover:font-medium
      group-hover:bg-blue-500 hover:bg-gradient-to-r hover:animate-background hover:from-blue-500 hover:to-fuchsia-500"
          >
            {title !== 'Boost simple planifié'
              ? 'Booster'
              : 'Planifier le boost'}
          </button>
        </div>
      </div>
    )}
  </>
);

export default BoostCard;
